/**
 * @license @tabler/icons-vue v3.29.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createVueComponent from '../createVueComponent.mjs';

var IconBinaryTree2Filled = createVueComponent("filled", "binary-tree-2-filled", "IconBinaryTree2Filled", [["path", { "d": "M12 3a3 3 0 0 1 2.616 4.47l3.274 3.742a3 3 0 1 1 -1.505 1.318l-3.275 -3.743l-.11 .042v6.342a3.001 3.001 0 1 1 -2 0v-6.342l-.111 -.041l-3.274 3.742a3 3 0 1 1 -1.505 -1.318l3.273 -3.742a3 3 0 0 1 2.617 -4.47", "key": "svg-0" }]]);

export { IconBinaryTree2Filled as default };
//# sourceMappingURL=IconBinaryTree2Filled.mjs.map
